import { createSelector } from '@reduxjs/toolkit';
import { selectHouseAreaAvailable } from 'shared/selectors/filters';
import { selectLandArea } from 'shared/selectors/jsonQuery';

export const selectLandAreaFilter = createSelector(
  [selectLandArea, selectHouseAreaAvailable],
  ({ gte = null, lte = null }, isHouseAreaAvailable) => ({
    label: isHouseAreaAvailable ? 'Участок' : undefined,
    valueMin: gte,
    valueMax: lte,
    min: 1,
    max: 99999,
  }),
);
